import React from 'react'
import { isEmpty } from 'lodash'

import errors from '../../lib/errors.js'
import ErrorDialog from '../UI/ErrorDialog'
import EditProjectType from './EditProjectType'
import BackButton from '../UI/BackButton'
import PageTitle from '../UI/PageTitle'
import LinearLoader from '../UI/LinearLoader'
import ProjectTypeNotFound from './ProjectTypeNotFound'

import Resource from '../../stores/resource'
const ProjectTypeStore = Resource('project-types')

class EditProjectTypePage extends React.PureComponent {
  constructor(props) {
    super(props)
    this.state = {
      projectType: {},
      error: '',
      loading: true
    }
  }

  componentDidMount() {
    ProjectTypeStore.find(this.props.match.params.id)
      .then(result =>
        this.setState({ projectType: result.data, loading: false })
      )
      .catch(error =>
        this.setState({
          projectType: {},
          error: errors.unpack(error),
          loading: false
        })
      )
  }

  _closeErrorDialog = () => this.setState({ error: '' })

  render() {
    const { loading, error, projectType } = this.state

    if (loading) return <LinearLoader />
    if (isEmpty(projectType)) return <ProjectTypeNotFound />

    return (
      <section>
        <header>
          <PageTitle>Edit Project type</PageTitle>
        </header>

        <EditProjectType projectType={projectType} />
        <br />
        <BackButton />

        <ErrorDialog
          open={Boolean(error)}
          closeCallback={this._closeErrorDialog}
        >
          <p>
            <strong>Error:</strong> {error}
          </p>
        </ErrorDialog>
      </section>
    )
  }
}

export default EditProjectTypePage



// WEBPACK FOOTER //
// ./src/components/ProjectTypes/EditProjectTypePage.jsx